<template>
    <CList @FiltrarC="Lista" :pConfigList="ConfigList" :pFiltro="Filtro" :segurity="segurity">

        <template slot="header">
            <th :class="StyleTh+' text-center'">#</th>
            <th :class="StyleTh">Nombre Completo</th>
            <th :class="StyleTh">Puesto</th>            
            <th :class="StyleTh+' text-center'">Acciones</th>
        </template>

        <template slot="body">
            <tr v-for="(lista,index) in ListaArrayRows" :key="index">
                <td class="text-center"><p :class="StyleTd">{{(index+1)}}</p></td>
                <td><h6 :class="StylePr">{{lista.NombreCompleto}}</h6></td>
                <td><p :class="StyleTd">{{lista.IdPuesto}}</p></td>
                
                <td class="align-middle text-end">
                    <button v-if="lista.visible" @click="SeleccionarPersonal(lista)" type="button" class="btn btn-link text-primary px-3 mb-0 mr-1"><i class="fas fa-check-circle text-primary"></i> Agregar</button>
                </td>
            </tr>
            <CSinRegistros :pContIF="ListaArrayRows.length" :pColspan="7"></CSinRegistros>
        </template>
    </CList>

</template>

<script>

import moment from 'moment';
import Configs from '@/helpers/VarConfig.js';
const EmitEjecuta = 'seccionPersonalSalida';

export default {
    name: 'ListaPersonal',
    props: ['poBtnSave'],
    components: {
    },
    data() {
        return {
            ConfigList:{
                Title: '',
                IsModal: true,
                ShowLoader: true,
                EmitSeccion: EmitEjecuta,
                BtnReturnShow: false,
                BtnNewShow: false,
                TitleFirst: '',
                ShowTitleFirst: false,
                ShowFooter: false,
            },
            Filtro:{
                Nombre: '',
                Pagina: 1,
                Entrada: 25,
                TotalItem: 0,
                Placeholder: 'Buscar..',
            },
            segurity: {},
            obj: {},
            ListaArrayRows: [],       
            Emit: this.poBtnSave.EmitSeccion,        
            StyleTh: Configs.stylesTable.StyleTh,
            StylePr: Configs.stylesTable.StylePr,
            StyleTd: Configs.stylesTable.StyleTd,
            ResponsableRecibe: 0,
        }
    },
    methods: {
		async Lista()
        {
            this.ConfigList.ShowLoader = true;

            await this.$http.get("users",{
                params:{
                    TxtBusqueda: this.Filtro.Nombre,
                    Entrada: this.Filtro.Entrada,
                    Pag: this.Filtro.Pagina,
                }
            }).then((res) => {
                this.Filtro.Pagina      = res.data.data.current_page;
                this.Filtro.TotalItem   = res.data.data.total;
                let response = res.data.data.data;
                //this.segurity           = res.data.segurity;
                
                let arr = this;

                response.map(function(element){
                    let visible = true;

                    if(element.IdUsuario == arr.ResponsableRecibe){
                        visible = false;
                    }

                    element.visible = visible;
                });

                this.ListaArrayRows = response;

            }).finally(()=>{
                this.ConfigList.ShowLoader = false;
            });
        },
        SeleccionarPersonal(item)
        {
            let obj = {
                ResponsableRecibe: item.IdUsuario,
                NombreResponsableRecibe: item.NombreCompleto,
            };

            this.bus.$emit('AgregarPersonal',obj);
            this.bus.$emit('CloseModal_'+this.Emit);
        },
    },
    created()
    {
        console.log(this.Emit)
        this.bus.$off('Recovery_'+this.Emit);
        this.bus.$on('Recovery_'+this.Emit,(obj)=>
        {
            console.log(obj)
            this.ResponsableRecibe = obj;

            this.Lista();

            this.bus.$off('List_'+EmitEjecuta);
            this.bus.$on('List_'+EmitEjecuta,()=>
            {
                this.Lista();
            });
        });
    },
}
</script>
